export const getDefaultState = () => {
  return {
    demo: null,
    menuBasicInfo: null,
    menuDetail: null
  }
}

const state = getDefaultState()
export default state
